import Grid from "@mui/material/Grid";
import Translate from "../../utils/Translate";

export default function AddressMenuItem({ street1, street2, zipCode, city, country, addressType, maxWidth }) {
  return (
    <Grid container whiteSpace="pre" maxWidth={maxWidth ?? "100%"}>
      <Grid size={9}>
        {street1?.trim() ? street1 : " "}
      </Grid>
      <Grid size={3}>
        <span
          style={{
            backgroundColor: "#EDEFF1",
            padding: "3px",
            borderRadius: "3px",
            fontSize: "smaller",
          }}
        >
          {Translate.getActorAddressType(addressType)}
        </span>
      </Grid>
      <Grid size={12}>
        {street2?.trim() ? street2 : " "}
      </Grid>
      <Grid size={12}>
        {`${zipCode?.trim() ? zipCode : " "} ${city?.trim() ? city : " "}`}
      </Grid>
      <Grid size={12}>
        {country?.trim() ? country : " "}
      </Grid>
    </Grid>
  );
}
